import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { graphql } from 'gatsby';
import shuffleArray from 'utils/shuffleArray';
import isArray from 'utils/isArray';

import bookingService from 'components/Booking-new/services/BookingService';
import useSelector from 'components/Booking-new/hooks';
import stepTypes from 'components/Booking-new/modules/Steps/types';

import Modal from 'mui/components/elements/DS_Modal';

import { DS_palette as corePalette } from '../../../../../../../../mui/base/theme/DS_Tokens/core';
import SurveyOption from './SurveyOption';
import { SurveyWrapper, StyledLoaderSpinner, OutterSurveyWrapper } from './styles';

export default function BookingSurvey({ data, setShowCES }) {
  const { results } = useSelector(state => ({
    stepSummary: state?.userData[stepTypes.summary],
  }));

  const [surveyOptionsList, setSurveyOptionsList] = useState([]);
  const [isSending, setIsSending] = useState(false);
  const { hasDelay } = data;

  const [openSurvey, setOpenSurvey] = useState(false);

  const onCloseModal = () => {
    setShowCES(true);
    setOpenSurvey(false);
  };

  const sendSelectedOption = async selectedLabel => {
    setIsSending(true);
    const body = { 'How did you hear about us?': selectedLabel };
    const userId = results.stepSummary?.userid;

    const { error } = await bookingService.saveHDYHAU(userId, body);

    if (error) console.log(error);

    setOpenSurvey(false);
    setShowCES(true);
  };

  const renderSurveyOption = option => (
    <SurveyOption
      key={`accordion-${option.label}`}
      name={option.name}
      label={option.label}
      sendSelectedOption={sendSelectedOption}
      isSending={isSending}
      setIsSending={setIsSending}
    />
  );

  useEffect(() => {
    const optionsList = data?.surveyOptionsList?.optionsList;
    if (!isArray(optionsList)) return;

    const shuffledOptionsList = shuffleArray(optionsList);
    if (!isArray(shuffledOptionsList)) setSurveyOptionsList(optionsList);
    else setSurveyOptionsList(shuffledOptionsList);
  }, []);

  useEffect(() => {
    setOpenSurvey(true);
  }, []);

  useEffect(() => {
    if (!hasDelay) return setOpenSurvey(true);
    const timeOut = setTimeout(() => {
      setOpenSurvey(true);
    }, 4000);
    return () => clearTimeout(timeOut);
  }, [hasDelay]);

  return (
    <Modal
      open={openSurvey}
      handleClose={onCloseModal}
      headingVariant="DS_copyBigBold"
      modalHeading={data.title}
      ariaDescribedby="modal-description"
      height="100%"
    >
      <OutterSurveyWrapper $isSending={isSending}>
        <SurveyWrapper>{surveyOptionsList?.map(option => renderSurveyOption(option))}</SurveyWrapper>
        {isSending ? <StyledLoaderSpinner color={corePalette.blue[500]} /> : null}
      </OutterSurveyWrapper>
    </Modal>
  );
}

BookingSurvey.propTypes = {
  data: PropTypes.shape({
    hasDelay: PropTypes.bool,
    successMessage: PropTypes.string,
    successImage: PropTypes.object,
    title: PropTypes.string.isRequired,
    surveyOptionsList: PropTypes.object,
  }),
};

export const query = graphql`
  fragment BookingSurvey on ContentfulComponentSurveyMultipleChoice {
    __typename
    id
    title
    successMessage
    hasDelay
    successImage {
      file {
        url
      }
    }
    surveyOptionsList {
      optionsList {
        name
        label
      }
    }
  }
`;
